import { Component, input, computed } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';

import type { InputSignal, Signal } from '@angular/core';
import type { ChipSelectOption } from './chip-select.domain';

@Component({
  imports: [
    TranslateDirective
  ],
  selector: 'td-wb-chip-select-trigger',
  templateUrl: 'chip-select-trigger.component.html',
  styleUrls: ['chip-select-trigger.component.scss']
})
export class ChipSelectTriggerComponent {
  readonly label: InputSignal<string> = input<string>('');
  readonly selectedOptions: InputSignal<Array<ChipSelectOption> | ChipSelectOption | undefined> = input<Array<ChipSelectOption> | ChipSelectOption | undefined>();

  protected readonly getSelectedOptions: Signal<Array<ChipSelectOption> | undefined> = computed(() => {
    if (Array.isArray(this.selectedOptions())) {
      return this.selectedOptions() as Array<ChipSelectOption>;
    }
    return this.selectedOptions() ? [this.selectedOptions() as ChipSelectOption] : [];
  });
}
